import Debug from 'debug';

export const debugTracking = Debug('tracking');
export const debugGlobals = Debug('globals');
